import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AcceptCookies, InitCookieSettings, InitCookieSettingsSuccess } from '@teamfoster/sdk/cookie-ngrx';
import { tap } from 'rxjs';
import Clarity from '@microsoft/clarity';
import { environment } from 'src/environments/environment';

let clarityInitialized = false;

export const clarityAcceptCookies$ = createEffect(
  (actions$ = inject(Actions), platformId = inject(PLATFORM_ID)) => {
    return actions$.pipe(
      ofType(AcceptCookies, InitCookieSettingsSuccess),
      tap(({ preferences }) => {
        if (!preferences || !isPlatformBrowser(platformId)) {
          return;
        }

        if (preferences.analytical) {
          if (!clarityInitialized) {
            Clarity.init(environment.clarityProjectId);
            clarityInitialized = true;
          }

          (window as any).clarity('start');

          const consentOptionSettings: { ad_Storage: 'granted' | 'denied'; analytics_Storage: 'granted' | 'denied' } = {
            ad_Storage: preferences.marketing ? 'granted' : 'denied',
            analytics_Storage: 'granted',
          };

          Clarity.consentV2(consentOptionSettings);
        } else if (clarityInitialized) {
          Clarity.consentV2({
            ad_Storage: 'denied',
            analytics_Storage: 'denied',
          });

          (window as any).clarity('stop');
        }
      })
    );
  },
  { dispatch: false, functional: true }
);
